import apiClient from '../apiClient';
import { POST_REGION_URL } from '../apiUrl';

const postRegionApi = data => {
  return apiClient.post(POST_REGION_URL, data);
};

export default postRegionApi;
